module.exports = __webpack_public_path__ + "img/alraay_logo.a58ccea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/alraay_logo.png
// module id = ./assets/img/media/arabic/alraay_logo.png
// module chunks = 0 12